export const REPORT_ENUM = Object.freeze({
  TABLE_READY: 1,
  REQUEST_AWAITING: 2,
  TABLE_LOADING: 3,
  TABLE_NO_DATA: 4,
});
